// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/ContactPerson.tsx

import { Mail } from "lucide-react";
import React, { useMemo } from "react";
import { useLanguage } from "../lang/index.lang.tsx";
import { employeesData, Employee, getEmployeesByIds } from "../lib/employees.tsx";

// Props der Komponente
interface ContactPersonProps {
  heading: {
    subtitle: string;
    title: string;
  };
  employeeIds: string[];
  className?: string;
}

const ContactPerson: React.FC<ContactPersonProps> = ({
  heading,
  employeeIds,
  className = "",
}) => {
  const { t } = useLanguage();
  
  // ✅ MIT useMemo - nur neu berechnen wenn employeeIds ändern
  // getEmployeesByIds macht: ids.map().filter() = TEURE Operation!
  const persons: Employee[] = useMemo(() => {
    return getEmployeesByIds(employeeIds);
  }, [employeeIds]);

  return (
    <div className={`w-full bg-black text-white mb-[150px] md:mb-[150px] lg:mb-[300px] ${className}`}>
      <div className="max-w-[1510px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Erste Zeile: Subtitle + Titel (volle Breite) */}
        <div className="mb-[50px]">
          <p className="text-white text-xl md:text-1xl lg:text-2xl mb-2">
            {heading.subtitle}
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold leading-tight mb-8">
            {heading.title}
          </h2>
        </div>
      </div>

      {/* Zweite Zeile: 2 Spalten Layout (50/50) */}
      <div className="max-w-[1510px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          {/* Linke Spalte: Leer auf Desktop */}
          <div className="hidden lg:block"></div>

          {/* Rechte Spalte: Grid mit Ansprechpartnern */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 px-1 md:px-2 lg:px-4">
            {persons.map((person) => (
              <div key={person.id} className="flex flex-col px-4 py-4 md:py-2 lg:py-2">
                {/* Foto - Responsive GrÃ¶ÃŸe */}
                <div className="mb-4 overflow-hidden w-[60%] lg:w-[70%] md:w-[60%]">
                  <img
                    src={person.photo}
                    alt={person.name}
                    className="w-full h-auto object-cover grayscale"
                  />
                </div>

                {/* Name - Responsive */}
                <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-2">
                  {person.name}
                </h3>

                {/* Email Icon */}
                <a
                  href={`mailto:${person.email}`}
                  className="inline-flex items-center text-white hover:text-gray-300 transition-colors duration-200"
                  aria-label={`Email ${person.name}`}
                >
                  <Mail size={20} className="md:w-[22px] md:h-[22px] lg:w-[24px] lg:h-[24px]" />
                </a>

                {/* Beschreibung aus Sprachdatei - font-serif wie in Showcase */}
                <p className="text-white text-xl md:text-1xl lg:text-2xl mt-3 md:mt-7 lg:mt-8 font-serif">
                  {t(person.descriptionKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPerson;